import { useQuery } from '@apollo/client/react';
import UnreadNotificationsCountQuery from 'queries/notification/unread_count';

const useUnreadNotificationsCount = () => {
  const {
    data = { unreadNotificationsCount: 0 },
    loading,
    refetch,
  } = useQuery(UnreadNotificationsCountQuery, {
    cachePolicy: 'cache-and-network',
  });

  return {
    count: data.unreadNotificationsCount ?? 0,
    loading,
    refetch,
  };
};

export default useUnreadNotificationsCount;
